<template>
  <div class="fixed-btn">
    <!-- 悬浮按钮 拨打电话 -->
    <img
      src="@/assets/img/orderGeneral/order_concat_customer@2x.png"
      @click="clickPhone"
    >
    <a
      :href="`tel:${phone}`"
      ref="telPhone"
      style="display:none;"
    />
  </div>
</template>

<script>
import {
  callPhone
} from '@/common/apiGeneral.js';
export default {
  name: 'PhoneCall',
  props: {
    phone: {
      type: String,
      required: true
    },
    taskNo: {
      type: String,
      required: true
    },
    taskStatus: {
      type: String,
      required: true
    }
  },
  data() {
    return {
    };
  },
  created() {
  },
  mounted() {
  },
  methods: {
    clickPhone() {
      this.$dialog.confirm({
        title: '提示',
        message:
          `确定拨打电话:${this.phone}`
      })
        .then(() => {
          // on confirm
          this.callPhone();
          this.$refs.telPhone.click();
        })
        .catch(() => {
          // on cancel
        });
    },
    async callPhone() {
      try {
        await callPhone({
          taskNo: this.taskNo,
          taskStatus: this.taskStatus
        });
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.fixed-btn{
  position: fixed;
  right: 10px;
  bottom: 120px;

  width: 60px;
  height: 60px;

  img{
    width: 100%;
    height: 100%;
  }
}
</style>
